<template>
  <div class="intermediaryGuarantee">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="content">
      <div class="hero-banner">
        <el-image class="hero-image" :src="require('@/assets/image/TradeTip/intermediary-head.png')" fit="cover"></el-image>
      </div>

      <div class="section-card intro-card">
        <div class="section-title">
          <el-image
            class="section-title-image"
            :src="require('@/assets/image/TradeTip/otherDescription.png')"
            fit="contain">
          </el-image>
        </div>
        <div class="otherDescription">
          <div class="desc-item">
            买家付账号全款以后，上号验号，与卖家描述相符即可过户账号资料。根据监管单位规定，平台会默认收取卖家身份证信息并验证真假，<span>如不能提供请提前告知客服</span>。
          </div>
          <div class="desc-item">
            <span>任意方取消交易，中介手续费不退。</span>
          </div>
          <div class="desc-item">
            <span>账号发生找回联系无果补偿号价10%(上限15000)，</span>可依法按规提供交易凭证、配合买家报警或起诉，建议购买包赔服务。
          </div>
          <div class="desc-item">
            <span>注：</span>个别游戏中介无售后和赔付，详情请在交易前咨询客服，以客服答复为准。
          </div>
        </div>
      </div>

      <div class="section-card charge-card">
        <div class="section-title">
          <el-image
            class="section-title-image"
            :src="require('@/assets/image/TradeTip/charge.png')"
            fit="contain">
          </el-image>
        </div>

        <div
          class="other-game"
          @click="goToCus(`https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/${Math.floor(Math.random()*10+1)}`)">
          <div class="other-game-mark">其他</div>
          <div class="other-game-action">
            <div class="other-game-title">其他游戏</div>
            <div class="other-game-text">未列出的游戏可咨询在线客服，获取专属中介费率</div>
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>

        <div class="game-list">
          <div class="game-item" v-for="(item,index) in gameList" :key="index" @click="goToCus(item.cus)">
            <div class="game-info">
              <el-image class="game-img" :src="item.img" fit="cover"></el-image>
              <div class="game-text">
                <div class="game-name">{{ item.gameName }}</div>
                <div class="game-price">{{ item.title1 }}</div>
                <div class="game-price" v-if="item.title2">{{ item.title2 }}</div>
              </div>
            </div>
            <div class="game-cus">
              <span>联系在线客服</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb";

export default {
  name: "intermediaryGuarantee",
  components: {
    Breadcrumb
  },
  data() {
    return {
      breadcrumbList: [{ name: "中介担保" }],
      gameList: [
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001023208_034052.png',
          gameName: '原神',
          title1: '号价2%（最低10）',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/7'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001024257_797181.png',
          gameName: '王者荣耀',
          title1: '手续费固定10元，首保10%，续保10%',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/5'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001022953_568399.png',
          gameName: '英雄联盟',
          title1: '手续费固定10元，首保10%，续保10%',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/10'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001021254_825941.png',
          gameName: '天刀端游',
          title1: '号价2%（最低30上限1000）',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/2'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001022112_462644.png',
          gameName: '和平精英',
          title1: '手续费固定10元，首保10%，续保10%',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/5'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001021952_847049.png',
          gameName: '剑灵',
          title1: '号价2%（最低30）',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/3'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001024209_495652.png',
          gameName: 'QQ三国',
          title1: '手续费固定10元，首保10%，续保8%（三国普通中介无售后）',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/4'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001023336_673717.png',
          gameName: 'DNF-地下城与勇士',
          title1: '手续费固定10元，首保10%，续保10%',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/5'
        }
      ]
    }
  },
  methods: {
    goToCus(url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang="less">

.intermediaryGuarantee {
  width: 1200px;
  min-height: max(680px, calc(100vh - 430px));
  background: var(--bg-page, #F7F5F2);
  border-radius: 4px;
  box-sizing: border-box;

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  /deep/ .title {
    width: 100%;
    margin-left: 0;
  }

  .content {
    padding: 0 0 32px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;
  }

  .hero-banner {
    width: 100%;
    min-height: 1px;
    background: var(--bg-card, #FFFFFF);
    overflow: hidden;
  }

  .hero-image {
    display: block;
    width: 100%;

    /deep/ img {
      width: 100%;
      height: auto;
      object-fit: contain;
      display: block;
    }
  }

  .section-card {
    width: 880px;
    margin: 34px auto 0;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
  }

  .section-title {
    height: 46px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .section-title-image {
    width: 318px;
    height: 46px;

    /deep/ img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
  }

  .otherDescription {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
    font-size: 15px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 24px;
  }

  .desc-item {
    min-height: 48px;
    padding: 13px 18px 13px 42px;
    position: relative;
    background: var(--bg-section, #F7F5F2);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      background: var(--primary, #FF5A1F);
      position: absolute;
      top: 21px;
      left: 20px;
      border-radius: 50%;
      box-shadow: 0 0 0 5px var(--primary-soft, #FCEDE5);
    }

    span {
      color: var(--text-main, #111827);
      font-weight: 600;
    }

  }

  .charge-card {
    padding-bottom: 28px;
  }

  .other-game {
    height: 96px;
    margin-bottom: 18px;
    padding: 0 24px 0 22px;
    position: relative;
    display: flex;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    background: var(--bg-tag, #F0EDE8);
    border: 1px solid rgba(26, 29, 36, 0.16);
    border-radius: 4px;
    transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      border-color: rgba(26, 29, 36, 0.32);
      box-shadow: 0 12px 24px rgba(26, 29, 36, 0.12);

      .el-icon-arrow-right {
        color: var(--primary, #FF5A1F);
      }
    }

    .el-icon-arrow-right {
      position: relative;
      margin-left: auto;
      color: var(--text-muted, #9AA0AC);
      font-size: 20px;
      z-index: 1;
      transition: color 0.2s ease;
    }
  }

  .other-game-mark {
    width: 58px;
    height: 58px;
    margin-right: 18px;
    flex: 0 0 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: var(--bg-dark, #1A1D24);
    box-shadow: 0 10px 18px rgba(26, 29, 36, 0.16);
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
  }

  .other-game-action {
    position: relative;
    z-index: 1;
    min-width: 0;
  }

  .other-game-title {
    margin-bottom: 8px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: var(--text-main, #111827);
    line-height: 28px;
  }

  .other-game-text {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 20px;
  }

  .game-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .game-item {
    min-height: 142px;
    padding: 18px 18px 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    cursor: pointer;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    box-shadow: 0 6px 18px rgba(26, 29, 36, 0.05);
    transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      border-color: rgba(26, 29, 36, 0.28);
      box-shadow: 0 12px 24px rgba(26, 29, 36, 0.12);

      .game-cus {
        color: var(--primary, #FF5A1F);
      }
    }
  }

  .game-info {
    display: flex;
    align-items: flex-start;
    min-height: 72px;
  }

  .game-img {
    width: 60px;
    height: 60px;
    min-width: 60px;
    margin-right: 14px;
    overflow: hidden;
    border-radius: 4px;
    background: var(--bg-tag, #F0EDE8);
    box-shadow: 0 4px 12px rgba(26, 29, 36, 0.08);

    /deep/ img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .game-text {
    min-width: 0;
    flex: 1;
  }

  .game-name {
    margin-bottom: 8px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 600;
    color: var(--text-main, #111827);
    line-height: 22px;
  }

  .game-price {
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 21px;
  }

  .game-cus {
    height: 34px;
    margin-top: 16px;
    padding-top: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid var(--border-soft, #E8E4DE);
    font-size: 14px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
    line-height: 20px;
    transition: color 0.2s ease;

    .el-icon-arrow-right {
      font-size: 14px;
    }
  }
}

</style>
